import type { TFunction } from 'i18next'

import { formatMoney } from '@/lib/utils'
import { PaymentType, type ClientReservation } from '@/types/api'

type Lesson = Pick<ClientReservation, 'client_paid'> & { order_received?: string | null }

/**
 * Čiastočne uhradená: lekcia je nezaplatená (objednávka nie je pokrytá celá),
 * ale na objednávku už niečo prišlo - záloha, alebo kurz, ktorému po úhrade
 * pribudla lekcia. Ukazovať ju ako „nezaplatenú“ by pôsobilo, že peniaze sa
 * stratili.
 */
export function partlyPaidAmount(lesson: Lesson): number {
  if (lesson.client_paid !== PaymentType.Unpaid) return 0
  const received = Number.parseFloat(lesson.order_received ?? '0')
  return received > 0 ? received : 0
}

/** „V hotovosti“, „Nezaplatené“, alebo „Čiastočne uhradené (75,00 €)“. */
export function paymentStatusLabel(t: TFunction, lesson: Lesson): string {
  const partly = partlyPaidAmount(lesson)
  if (partly) return t('reservation.partlyPaid', { amount: formatMoney(partly) })
  return t(`reservation.payment.${lesson.client_paid}`)
}
